import { collection, deleteDoc, doc, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export async function deleteNewsArticleWithSubcollections(articleId) {
  const commentsSnap = await getDocs(collection(db, 'newsArticles', articleId, 'comments'));
  for (const commentDoc of commentsSnap.docs) {
    await deleteDoc(commentDoc.ref);
  }

  const flagsSnap = await getDocs(collection(db, 'newsArticles', articleId, 'flags'));
  for (const flagDoc of flagsSnap.docs) {
    await deleteDoc(flagDoc.ref);
  }

  await deleteDoc(doc(db, 'newsArticles', articleId));
}
